import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  (muiTheme) => ({
    content: {
      '& > * + *': {
        marginTop: muiTheme.spacing(3),
      },
    },
    container: {
      '& > * + *': {
        marginTop: '32px',
      },
    },
    doubleSpacing: {
      '&:not(:first-child)': {
        marginTop: '58px',
      },

      '& + *': {
        marginTop: '58px',
      },
    },
    inset: {
      '&': {
        [muiTheme.breakpoints.up('md')]: {
          padding: '0 32px',
        },
      },
    },
    offset: {
      '&': {
        [muiTheme.breakpoints.up('md')]: {
          marginLeft: '-32px',
          marginRight: '-32px',
        },
      },
    },
    columnContent: {
      '& .columns': {
        '& .column': {
          '& > * > * + *': {
            marginTop: muiTheme.spacing(3),
          },
        },
      },
    },
    columnCenterAlign: {
      '& .columns': {
        alignItems: 'center',
        alignContent: 'center',
      },
    },
    columnBottomAlign: {
      '& .columns': {
        alignItems: 'flex-end',
        alignContent: 'flex-end',
      },
    },
    root: {},
  }),
  { name: 'GenTPDMainContent' },
);

export default useStyles;
